export function Flash() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.248 3.00049H11.998L7.49805 20.2505H13.498L10.498 33.0005L29.998 12.0005H20.998L23.248 3.00049Z"
        fill="#148F4A"
        stroke="#051D29"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.748 8.25098L14.248 14.251"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}
